/**
 * Blue Brand Theme — Figma Spec
 *
 * All hex values taken directly from the Figma "CTA Button & Interactive
 * Component States" design file.
 *
 * Every token references the canonical palette so there is a single source
 * of truth for each raw hex value.
 */
import type { BrandTokens } from './types';
import { palette } from '../colorGroups/palette.colors';

export const blueTheme: BrandTokens = {
  /** Default solid fill — primary buttons, active tab, shift banner, icon-toggle active */
  primary: palette.blue.selectedText,        // '#005FCC'

  /** Hover fill */
  primaryHover: palette.blue.hover,          // '#004EAB'

  /** Pressed / deepest fill */
  primaryPressed: palette.blue.pressed,      // '#002859'

  /** Light tint fill — inactive-tab BG, outlined-button hover fill, selected-row BG */
  primaryTint: palette.blue.selectedItemBG,  // '#E6F1FF'

  /** Medium tint fill — outlined-button pressed fill */
  primaryTintMed: palette.borders.dropdownBlue, // '#CCE3FF'

  /** Outline / border — secondary button border, card selected border, pagination border */
  primaryBorder: palette.blue.selectedBorder, // '#66ABFF'

  /** Badge / counter background */
  primaryBadge: palette.blue.badge,          // '#004EA8'

  /** Text & icons drawn ON solid primary fills */
  onPrimary: palette.gray.white,             // '#FFFFFF'

  /** Text & icons drawn ON light tint fills or outlined components */
  onTint: palette.blue.onTint,              // '#020617'

  /** App-level page background — lightest blue-white canvas (#F5F9FF per Figma) */
  pageBackground: palette.blue.appBG,        // '#F5F9FF'

  /** Soft/pastel blue — between tintMed (#CCE3FF) and border (#66ABFF) */
  primarySoft: palette.blue.soft,            // '#99C7FF'
};